import React from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router-dom'
import { Button } from 'loyal-react'
import { ProductImageDonation } from '../ProductImageDonation'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'
import DonationImage from '@loyal_images/products/icon_donation.svg'

const ProductOrderItemDonation = props => (
  <div className='cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'>
    <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
      <ProductImageDonation
        imageUrl={DonationImage}
        alt={props.productName}
        vendorId={props.vendorId}
        vendorType={props.vendorType}
        ready
      />
    </div>

    <div className='cart-product-info col'>
      <div className='cart-product-info row align-items-center h-100'>
        <div className='col-12 col-md-8'>
          <div className='row'>
            <div className='order-number col-12 mx-0 mb-1'>
              <p className='txt-font-body txt-body'>
                Pedido: #00000007
              </p>
            </div>
            <div className='product-infos col-12 mx-0'>
              <h2 className='txt-body-sm txt-font-body color-ui-2 '>
                Doação de pontos
              </h2>
            </div>
          </div>
          <div className='row card-price-item  mt-1'>
            <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              Valor: <strong>5.000 pts</strong>
            </div>
            <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              Realizado em:{' '}
              <strong>
                17/10/2018
              </strong>
            </div>
          </div>
        </div>
        <div className='col d-none d-md-block'>
          <Button
            className='btn btn-sm btn-featured btn-cart'
            text='Ver detalhes'
            onClick={() => {
              window.location.href = '/my-orders'
            }}
          />
        </div>
      </div>
    </div>
    <div className='col-12 d-block d-md-none mt-1'>
      <Button
        className='btn btn-sm btn-featured btn-cart'
        text='Ver detalhes'
        onClick={() => {
          window.location.href = '/my-orders'
        }}
      />
    </div>
  </div>
)

ProductOrderItemDonation.propTypes = {
  productName: PropTypes.string,
  vendorType: PropTypes.string,
  vendorId: PropTypes.number
}

export default ProductOrderItemDonation



// WEBPACK FOOTER //
// ./src/features/ConfirmationDonation/ProductOrderItemDonation.js